import * as Storage from './storage';
import * as Plugins from './plugins';
import * as Services from './plugins';

export const GeoLocation = {
    Plugins,
    Storage,
    Services
};
